import React from 'react';
import { View, Text, StyleSheet, Dimensions, Animated, Easing } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { Entypo } from '@expo/vector-icons';
import moment from 'moment';
import UserState from '../../src/contexts/UserState';

const CountdownTimer = ({ date, freshdeskId, ...props }) => {
  const [user, setUser] = React.useContext(UserState);
  const [textDays1, setTextDays1] = React.useState('');
  const [textDays2, setTextDays2] = React.useState('');
  const [textHours1, setTextHours1] = React.useState('');
  const [textHours2, setTextHours2] = React.useState('');
  const [textMins1, setTextMins1] = React.useState('');
  const [textMins2, setTextMins2] = React.useState('');
  const [textSecs1, setTextSecs1] = React.useState('');
  const [textSecs2, setTextSecs2] = React.useState('');
  const [widths, setWidths] = React.useState([{}, {}, {}]);
  const [blurbText, setBlurbText] = React.useState('');
  const [deadlinePast, setDeadlinePast] = React.useState(false);
  // const [formattedDate, setFormattedDate] = React.useState(false);

  const width = Dimensions.get('window').width;
  let interval = null;
  const rotateAnim = React.useRef(new Animated.Value(0)).current;

  // let widths = [{},{},{}];
  
  React.useEffect(() => {
    if(date){
      console.log('useEffect date: ', date);
      getWidths();
      textTime();
      startAnimation();
      setBlurb();
    // setFormattedDate(moment(date).format("ddd, MMM Do YYYY, h:mm:ssa"));
    }

    return () => {
      clearInterval(interval);
      rotateAnim.stopAnimation();
    }
  }, [date]);

  const setBlurb = () => {
    if (props.type === 'milestone'){
      if (user.isContractor) {
        setBlurbText((freshdeskId == user.freshdesk_id) ? 'You have up to 7 days to respond' : 'Your customer has up to 7 days to respond.');
      } else {
        setBlurbText((freshdeskId == user.freshdesk_id) ? 'You have up to 7 days to respond' : 'Your contractor has up to 7 days to respond.');
      }
    }else if(props.type === 'dispute'){
      setBlurbText('You have up to 7 days to respond');
    }
  }

  const startAnimation = () => {
    console.log('startAnimation()');
    Animated.loop(
      Animated.timing(
        rotateAnim,
        {
          toValue: 1,
          duration: 60000,
          easing: Easing.linear,
          useNativeDriver: true,
        }
      )
    ).start();
  }
  const spin = rotateAnim.interpolate({
    inputRange: [0,1],
    outputRange: ['0deg', '360deg'],
  });

  const textTime = () => {
    // let deadline = moment(date, 'YYYY-MM-DD hh:mm:ss');
    // let deadline = moment(date, 'YYYY-MM-DDThh:mm:ssZ');
    let deadline = moment(date);
    let now = moment();
    if(deadline.isAfter(now)){
      // startAnimation();
      let days = 0;
      let hours = 0;
      let mins = 0;
      let secs = 0;

      // let difference = deadline.diff(now);
      // days = deadline.diff(now, 'days');
      // hours = deadline.diff(now, 'hours') - (days * 24);
      // mins = deadline.diff(now, 'minutes') - (hours * 60);
      // secs = deadline.diff(now, 'seconds') - (mins * 60);

      let duration = moment.duration(deadline.diff(now));
      days = duration.get('days');
      hours = duration.get('hours');
      mins = duration.get('minutes');
      secs = duration.get('seconds');

      // console.log('difference: ', difference);
      // console.log('days: ', days);
      // console.log('hours: ', hours);
      // console.log('mins: ', mins);
      // console.log('secs: ', secs);

      setTextDays1(days);
      setTextDays2(` day${plural(days)}`);
      setTextHours1(hours);
      setTextHours2(`hr${plural(hours)}`);
      setTextMins1(mins);
      setTextMins2(`min${plural(mins)}`);
      setTextSecs1(secs);
      setTextSecs2(`sec${plural(secs)}`);

      if(!interval){
        interval = setInterval(textTime, 1000);
      }
    }else{
      // deadline has past
      console.log('deadline has past');
      console.log('now: ', now.toString());
      console.log('deadline: ', date, deadline.toString());
      setDeadlinePast(true);
      props.setDeadlinePast(true);
      clearInterval(interval);
      rotateAnim.stopAnimation();
    }
  }

  const plural = (value) => {
    return value > 1 ? 's' : '';
  }

  const timerDimensions1 = () => {
    console.log('Dimensions width: ', width);
    if(width > 375){
      return {
        width: 355,
        height: 355,
        borderRadius: 355,
      }
    }else{
      return {
        width: width - 20,
        height: width - 20,
        borderRadius: width - 20,
      }
    }
  }
  const timerDimensions2 = () => {
    console.log('Dimensions width: ', width);
    if (width > 375) {
      return {
        width: 310,
        height: 310,
        borderRadius: 310,
      }
    } else {
      return {
        width: width - 65,
        height: width - 65,
        borderRadius: width - 65,
      }
    }
  }
  const timerDimensions3 = () => {
    console.log('Dimensions width: ', width);
    if (width > 375) {
      return {
        width: 235,
        height: 235,
        borderRadius: 235,
      }
    } else {
      return {
        width: width - 140,
        height: width - 140,
        borderRadius: width - 140,
      }
    }
  }
  const getWidths = () => {
    const widths = [
      timerDimensions1(),
      timerDimensions2(),
      timerDimensions3(),
    ];
    setWidths(widths);
  }

  return (
    <View style={styles.container}>
      <View style={[styles.timer, widths[0]]}>
        <View style={[styles.timer2, widths[1]]}>
          <View style={[styles.timer3, widths[2]]}>
            <Entypo name="stopwatch" size={42} color={Colors.lightBlue} style={styles.icon} />
            {!deadlinePast && 
              <View style={styles.textContainer}>
                <Text style={[CS.lightText, CS.largeText, CS.boldText, styles.textTime1]}>{textDays1}<Text style={styles.textTime2}>{textDays2}</Text></Text>
                <Text style={[CS.lightText, CS.largeText, CS.boldText, styles.textTime1]}>{textHours1}<Text style={styles.textTime2}>{textHours2}</Text> {textMins1}<Text style={styles.textTime2}>{textMins2}</Text></Text>
                <Text style={[CS.lightText, CS.largeText, CS.boldText, styles.textTime1]}>{textSecs1}<Text style={styles.textTime2}>{textSecs2}</Text></Text>
              </View>
            }
            {deadlinePast &&
              // <View>
                <Text style={[CS.redText, CS.largeText, styles.textTime1]}>Deadline Past</Text>
              // </View>
            }
          </View>
          <Animated.View style={[styles.timer4, widths[2], { transform: [{ rotate: spin }] }]}></Animated.View>
        </View>
      </View>
      {/* <Text style={[CS.lightBlueText, CS.mediumText, CS.yellowText, { marginTop: 20 }]}>{formattedDate}</Text> */}
      <Text style={[CS.lightBlueText, CS.smallText, { marginTop: 20 }]}>{props.message || blurbText}</Text>
    </View>
  );

}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  timer: {
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.blue2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  timer2: {
    position: 'absolute',
    borderWidth: 20,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.blue2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  timer3: {
    position: 'absolute',
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.blue2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  timer4: {
    position: 'absolute',
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: Colors.lightBlue2,
    // transform: [{ rotate: '2deg' }]
  },
  icon: {
    position:'absolute',
    top: 20,
  },
  textContainer: {
    paddingHorizontal: 10,
    alignItems: 'center',
    marginTop: 20,
  },
  textTime1: {
    marginTop: 5,
    fontSize: 32,
  },
  textTime2: {
    fontSize: 24,
  }
});

export default CountdownTimer;